/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { memo, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ChatIcon from '@material-ui/icons/Chat';
import TimelineIcon from '@material-ui/icons/Timeline';
import MultilineChartIcon from '@material-ui/icons/MultilineChart';
import ImportContactsIcon from '@material-ui/icons/ImportContacts'
import CloudIcon from '@material-ui/icons/Cloud'
import ResumCommentsList from 'src/components/insigth/ResumCommentsList';
import VideoCommentsList from 'src/components/insigth/VideoCommentsList'
import InputEditList from 'src/components/insigth/InputsEditList'
import VideoListInside from 'src/components/insigth/VideoListInside'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import ListInsideSentiments from 'src/components/insigth/ListInsideSentiments'
import { TabPanel, a11yProps } from 'src/components/sharedComponents/TapPanel'
import WordsList from 'src/components/insigth/WordsList'
import VideoSearchInsingth from 'src/components/insigth/VideoSearchInsigth'
import AnalysisCard from 'src/components/insigth/AnalysisCard'
import SearchBar from 'src/components/insigth/SearchBar'
import ListHeaterComments from 'src/components/insigth/ListHeaterComments';
import { GiChewedSkull } from 'react-icons/gi'
import { useStyles } from './styles'

const YoutubePageDetail = (props) => {
  const {
    tab,
    videos,
    words,
    comments,
    onChange,
    videoList,
    feelings,
    isAnalyzed,
    onSearch,
    listItem,
    setIsEdit,
    activeStep,
    pageWords,
    gp3Comments,
    temperature,
    handleChangeLimit,
    loadingFeelings,
    setActiveStep,
    handleChangeTap,
    handleSearch,
    handleClose,
    reloadFeelings,
    onEditList,
    activeStepSearch,
    handleRemoveAnalysis,
    handleBackSearchVideo,
    handleNextSearchVideo,
    confirmContext,
    evaluateSentiment,
    handleFeelingsById,
    handleSelectOption,
    addToVideoItemList,
    handleAnalyzeVideos,
    handleDeleteVideoList,
    onChangeTemperature,
    handleForzeCommets,
    onDelete,
    handleCommetsByVideoId,
  } = props
  const [title, setTitle] = useState('')
  const classes = useStyles()

  return (
    <div style={{ margin: '10px' }}>
      <CardTitle title={`Detalle: ${listItem.nombre}`} />
      <InputEditList
        isEdit={props.isEdit}
        setIsEdit={setIsEdit}
        listItem={listItem}
        onChange={onChange}
        onDelete={onDelete}
        onEditList={onEditList}
      />
      <SearchBar
        videos={videos?.videos}
        search={props.search}
        onSearch={onSearch}
        handleSearch={handleSearch}
        isAnalyzed={isAnalyzed}
        handleAnalyzeVideos={handleAnalyzeVideos}
      />
      <VideoListInside
        videos={videos?.videos}
        loading={videos.loading}
        handleFeelingsById={(videoId, newTitle) => {
          handleFeelingsById(videoId)
          setTitle(newTitle)
        }}
        handleDeleteVideoList={handleDeleteVideoList}
        handleCommetsByVideoId={(videoId, newTitle) => {
          handleCommetsByVideoId(videoId)
          setTitle(newTitle)
        }}
      />
      <VideoSearchInsingth
        open={props.open}
        videos={videoList}
        loading={videoList.loading}
        activeStepSearch={activeStepSearch}
        handleClose={handleClose}
        addToVideoItemList={addToVideoItemList}
        handleNextSearchVideo={handleNextSearchVideo}
        handleBackSearchVideo={handleBackSearchVideo}
      />
      <AnalysisCard
        title={title}
        setTitle={setTitle}
        listItem={listItem}
        activeStep={activeStep}
        reloadFeelings={reloadFeelings}
        setActiveStep={setActiveStep}
        handleRemoveAnalysis={handleRemoveAnalysis}
      />
      <div className={classes.appBarRoot}>
        <AppBar className={classes.appBar} id="appbar" position="static">
          <Tabs
            id="Tabs"
            value={tab}
            onChange={handleChangeTap}
            aria-label="simple tab"
            variant="scrollable"
            scrollButtons="on"
          >
            <Tab
              label="Sentimientos +"
              {...a11yProps(0)}
              icon={<TimelineIcon />}
            />
            <Tab
              label="Sentimientos -"
              {...a11yProps(1)}
              icon={<MultilineChartIcon />}
            />
            <Tab
              label="Nube de Palabras"
              {...a11yProps(2)}
              icon={<CloudIcon />}
            />
            <Tab label="Comentarios" {...a11yProps(3)} icon={<ChatIcon />} />
            <Tab
              label="Resumen"
              {...a11yProps(4)}
              icon={<ImportContactsIcon />}
            />
            <Tab
              label="Haters"
              {...a11yProps(5)}
              icon={<GiChewedSkull size="25" />}
            />
          </Tabs>
        </AppBar>

        <div className={classes.root}>
          <TabPanel value={tab} index={0}>
            <ListInsideSentiments
              feelings={feelings}
              loading={loadingFeelings.loading}
              evaluateSentiment={evaluateSentiment}
              confirmContext={confirmContext}
              handleSelectOption={handleSelectOption}
            />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <ListInsideSentiments
              feelings={feelings}
              loading={loadingFeelings.loading}
              evaluateSentiment={evaluateSentiment}
              confirmContext={confirmContext}
              handleSelectOption={handleSelectOption}
            />
          </TabPanel>
          <TabPanel value={tab} index={2}>
            <WordsList
              words={words}
              pageWords={pageWords}
              handleChangeLimit={handleChangeLimit}
            />
          </TabPanel>
          <TabPanel value={tab} index={3}>
            <VideoCommentsList comments={comments} />
          </TabPanel>
          <TabPanel value={tab} index={4}>
            <ResumCommentsList
              onChangeTemperature={onChangeTemperature}
              handleForzeCommets={handleForzeCommets}
              gp3Comments={gp3Comments}
              temperature={temperature}
            />
          </TabPanel>
          <TabPanel value={tab} index={5}>
            <ListHeaterComments heater={props.heater} />
          </TabPanel>
        </div>
      </div>
    </div>
  )
}

export default memo(YoutubePageDetail)
